// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3VVGR","footer":"Form_footer__2abor"};